import {
  Autocomplete,
  Checkbox,
  FormControlLabel,
  Grid,
  TextField,
} from '@mui/material';
import { LeftOutlined } from '@ant-design/icons';
import { Form, Formik } from 'formik';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import { MagnifyingGlass } from '@phosphor-icons/react';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import styled from 'styled-components';
import { Fragment } from 'react';

import { Field } from 'components/field';
import { top100Films } from 'mock/subUserData';

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;
interface FromItemsProps<T> {
  title: string;
  selectOptions?: Array<{ label: string; value: string }>;
  searchOptions?: T[];
  hidden?: Partial<{ select: boolean; autoComplete: boolean }>;
  checkLabel?: string;
}
const formItems: FromItemsProps<{
  title: string;
  year: number;
}>[] = [
  {
    title: 'Invoices',
    selectOptions: [{ label: 'Select Access', value: 'Select Access' }],
    searchOptions: top100Films,
  },
  {
    title: 'Cost',
    selectOptions: [{ label: 'Select Access', value: 'Select Access' }],
    searchOptions: top100Films,
  },
  {
    title: 'Debitor',
    selectOptions: [{ label: 'Select Access', value: 'Select Access' }],
    hidden: { autoComplete: true },
  },
  {
    title: 'Creditor',
    selectOptions: [{ label: 'Select Access', value: 'Select Access' }],
    hidden: { autoComplete: true },
  },
  {
    title: 'Act',
    hidden: { select: true, autoComplete: true },
    checkLabel: 'Create',
  },
  {
    title: 'E-qaime',
    hidden: { select: true, autoComplete: true },
    checkLabel: 'Create',
  },
  {
    title: 'Manager',
    hidden: { select: true, autoComplete: true },
    checkLabel: 'Create',
  },
  {
    title: 'Job number',
    hidden: { select: true, autoComplete: true },
    checkLabel: 'Create',
  },
  {
    title: 'Reportlar',
    hidden: { select: true },
    searchOptions: top100Films,

    checkLabel: 'View',
  },
];
export const SubUserEdit = () => {
  return (
    <div>
      <StyledBox>
        <div className="flex">
          <StyledIconBox>
            <LeftOutlined style={{ fontSize: '8px', color: '#466AFB' }} />
          </StyledIconBox>
          <div className="ml-4">
            <UserName>Konul Rzayeva</UserName>
            <div className="text-base font-normal opacity-50">Operator</div>
          </div>
        </div>
      </StyledBox>
      <Wrapper>
        <Formik initialValues={{}} onSubmit={(values) => {}} enableReinitialize>
          {({ handleChange }) => (
            <StyledForm>
              <Grid container spacing={3}>
                <Grid xl={3.5} md={12} xs={12} item>
                  <Field label="Name Surname" name="fullName" />
                </Grid>
                <Grid xl={3.5} md={12} xs={12} item>
                  <Field label="Mail" name="mail" />
                </Grid>
                <Grid xl={3.5} md={12} xs={12} item>
                  <Field
                    onChange={handleChange}
                    label="Status"
                    name="status"
                    as="select"
                  >
                    {[{ label: 'active', value: 'active' }].map((item) => (
                      <option key={item.label} value={item.label}>
                        {item.value}
                      </option>
                    ))}
                  </Field>
                </Grid>
              </Grid>
              <Line />
              <UserTitle>User Access</UserTitle>
              {formItems.map((item) => (
                <Fragment key={item.title}>
                  <Grid
                    container
                    alignItems="flex-start"
                    sx={
                      !item?.hidden?.autoComplete && item.searchOptions?.length
                        ? { height: '380px' }
                        : undefined
                    }
                  >
                    <Grid item xl={4} md={4} xs={12}>
                      <Title>{item.title}</Title>
                    </Grid>
                    <Grid item xl={4} md={4} xs={12}>
                      <Grid container spacing={2} alignItems="flex-end">
                        <Grid xl={6} md={6} xs={12} item>
                          {!item?.hidden?.select &&
                          item.selectOptions?.length ? (
                            <Field
                              onChange={handleChange}
                              label="Select Access"
                              name="selectAccess"
                              as="select"
                            >
                              {item.selectOptions.map((item) => (
                                <option key={item.label} value={item.label}>
                                  {item.value}
                                </option>
                              ))}
                            </Field>
                          ) : (
                            <FormControlLabel
                              control={<Checkbox defaultChecked />}
                              label={item.checkLabel}
                            />
                          )}
                        </Grid>
                        {!item?.hidden?.autoComplete &&
                          item.searchOptions?.length && (
                            <Grid item xl={6} md={6} xs={12}>
                              <AutoCompleteWrapper>
                                <Autocomplete
                                  multiple
                                  options={item.searchOptions}
                                  getOptionLabel={(option) => option?.title}
                                  open
                                  ListboxProps={{
                                    style: {
                                      maxHeight: '320px',
                                    },
                                  }}
                                  componentsProps={{
                                    popper: {
                                      modifiers: [
                                        {
                                          name: 'flip',
                                          enabled: false,
                                        },
                                        {
                                          name: 'preventOverflow',
                                          enabled: false,
                                        },
                                      ],
                                    },
                                  }}
                                  renderOption={(
                                    props,
                                    option,
                                    { selected }
                                  ) => (
                                    <li {...props}>
                                      <Checkbox
                                        icon={icon}
                                        checkedIcon={checkedIcon}
                                        style={{ marginRight: 8 }}
                                        checked={selected}
                                      />
                                      <OptionTitle>{option.title}</OptionTitle>
                                    </li>
                                  )}
                                  renderTags={() => null}
                                  style={{ width: 332, borderColor: '#466afb' }}
                                  renderInput={(params) => (
                                    <TextField
                                      {...params}
                                      placeholder="Search for "
                                      inputProps={{
                                        style: {
                                          paddingLeft: '28px',
                                          height: 15,
                                        },

                                        ...params.inputProps,
                                      }}
                                    />
                                  )}
                                />
                                <SearchIcon />
                              </AutoCompleteWrapper>
                            </Grid>
                          )}
                      </Grid>
                    </Grid>
                  </Grid>

                  <Line />
                </Fragment>
              ))}
            </StyledForm>
          )}
        </Formik>
      </Wrapper>
    </div>
  );
};

export const Wrapper = styled.div``;

export const StyledBox = styled.div`
  background: rgba(70, 106, 251, 0.02);
  padding: 24px 0px 16px 24px;
`;

export const Line = styled.div`
  border: 1px solid rgba(70, 106, 251, 0.06);
  margin: 30px 0;
`;
export const UserTitle = styled.h4`
  font-weight: 700;
  font-size: 20px;

  color: #466afb;
`;
export const Title = styled.h4`
  font-weight: 500;
  font-size: 18px;
  color: #292d32;
  width: 150px;
`;
export const OptionTitle = styled.h4`
  font-size: 14px;

  color: #292d32;
`;
export const SearchIcon = styled(MagnifyingGlass)`
  position: absolute;
  top: 25%;
  left: 6px;
  color: #466afb;
  font-size: 25px;
`;
export const AutoCompleteWrapper = styled.div`
  /* display: flex; */
  position: relative;
  .MuiOutlinedInput-notchedOutline {
    border-color: rgb(70, 106, 251);
  }
`;
export const StyledForm = styled(Form)`
  padding: 20px;
`;
export const UserName = styled.div`
  font-family: 'Mark Pro';
  font-style: normal;
  font-weight: 500;
  font-size: 24px;
  color: #292d32;
  line-height: 100%;
  margin-bottom: 16px;
`;

export const StyledIconBox = styled.div`
  border-radius: 5px;
  border: 1.5px solid #466afb;
  height: 16.67px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 16.67px;
`;
